import { eur, hrs, fmtDate } from "@/lib/apiClient";

const fmtAt = (s) => (s ? new Date(s).toLocaleString("en-IE", { dateStyle: "short", timeStyle: "short" }) : "");

function Diff({ b, a }) {
  const rows = [
    ["Site", b.site_name, a.site_name], ["Job type", b.job_type, a.job_type], ["Description", b.description, a.description],
    ["Times", `${b.start_time}–${b.finish_time}`, `${a.start_time}–${a.finish_time}`], ["Travel", `${b.travel_minutes || 0} min`, `${a.travel_minutes || 0} min`],
    ["Paid hours", hrs(b.paid_hours), hrs(a.paid_hours)], ["Pay", eur(b.labour_cost), eur(a.labour_cost)], ["Charge", eur(b.labour_charge), eur(a.labour_charge)],
  ].filter(([, x, y]) => (x || "") !== (y || ""));
  return rows.map(([l, x, y]) => <div key={l} className="num"><span className="text-zinc-500">{l}:</span> <span className="line-through text-zinc-400">{x || "—"}</span> → <span className="font-medium">{y || "—"}</span></div>);
}

export function CorrectionHistory({ items }) {
  if (!items?.length) return null;
  return (
    <div data-testid="correction-history" className="border border-violet-200 bg-violet-50/40 rounded-md p-3 mb-2 text-xs">
      <div className="font-bold text-sm mb-2">Corrections after approval</div>
      <div className="space-y-2">
        {[...items].reverse().map((c, i) => (
          <div key={i} data-testid={`correction-${i}`} className="border-b border-violet-100 pb-2 last:border-0">
            <div className="font-medium">{fmtDate(c.date)} entry · by {c.by} · {fmtAt(c.at)}{c.payroll_run ? " · after payroll" : ""}</div>
            <div className="italic text-zinc-600">Reason: {c.reason}</div>
            <Diff b={c.before || {}} a={c.after || {}} />
          </div>
        ))}
      </div>
    </div>
  );
}
